import React, { useState } from "react";
import Img from "../Img";

export default function AdditionalDataToggle(props) {
    const [toggled, setToggled] = useState(false);
    const message = props.message;

    if (message == null) {
        return null;
    }

    function toggle(e) {
        e.stopPropagation();
        e.preventDefault();
        setToggled(!toggled);
    }

    return (
        <div className="c_65" onClick={toggle}>
            <Img className="c_65_1" src="icon_info.svg" height="16px" width="16px" />
            {toggled &&
                <div className="c_65_2">{message}</div>
            }
        </div>
    );
}
